// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container___UAOy","title":"index_title__34RxS","desc":"index_desc__baItv","cardContainer":"index_cardContainer__E77Hq"};